import React from "react";
import "./style.css";
export default function OfferPrice(props) {
    var _a, _b, _c;
    if (props.offer.forEveryImage == false &&
        props.offer.isBeforePayment === true) {
        return React.createElement(React.Fragment, null);
    }
    if (props.offer.forEveryImage === false &&
        props.offer.offerType === "promotion")
        return React.createElement(React.Fragment, null);
    if (props.offer.forEveryImage === false) {
        if (typeof props.offer.price !== "number")
            return React.createElement(React.Fragment, null);
        return (React.createElement("div", { className: "offer-price-container" },
            React.createElement("b", null,
                props.offer.name,
                ":"),
            " ",
            props.offer.price,
            " z\u0142"));
    }
    return (React.createElement("div", { className: "offer-price-container" },
        React.createElement("b", null, (_a = props.offer.labelName) !== null && _a !== void 0 ? _a : props.offer.name,
            ":"),
        React.createElement("div", { className: "offer-price-formats-container" }, (_b = props.offer) === null || _b === void 0 ? void 0 :
            _b.formats.map((format, index) => (React.createElement("div", { className: "offer-price-format", key: index },
                format.priceListOverrideWith !== undefined && (React.createElement(React.Fragment, null, format.priceListOverrideWith)),
                (typeof format.defaultPrice === "number" &&
                    !format.priceListOverrideWith &&
                    format["@hidden"] !== true) ?
                    React.createElement(React.Fragment, null,
                        format.overridePrefix !== undefined ?
                            format.overridePrefix
                            : "Format",
                        " ",
                        format.name,
                        ": ",
                        format.defaultPrice,
                        " z\u0142")
                    : React.createElement(React.Fragment, null)))),
            ((_c = props.offer.electronicOffer) === null || _c === void 0 ? void 0 : _c.enabled) &&
                typeof props.offer.electronicOffer.price === "number" && (React.createElement("div", null,
                "Wersja elektroniczna: ",
                props.offer.electronicOffer.price,
                " z\u0142")))));
}
